import React from 'react'
import { TouchableOpacity, StyleProp, ViewStyle } from 'react-native'
import Styles from './style'
import Typography from 'APP/Converse/Typography'

export const DebugButton = ({
  onPress,
  style,
  inline = false,
}: {
  onPress: () => void
  style?: StyleProp<ViewStyle>
  inline?: boolean
}) => (
  <TouchableOpacity
    style={[style, Styles.fab, inline && Styles.fabInline]}
    onPress={onPress}
    testID="SPIDER"
  >
    <Typography>🕷</Typography>
  </TouchableOpacity>
)

export default DebugButton
